import { render, staticRenderFns } from "./aboutListItem.vue?vue&type=template&id=2018b9c9&scoped=true"
import script from "./aboutListItem.vue?vue&type=script&lang=js"
export * from "./aboutListItem.vue?vue&type=script&lang=js"
import style0 from "./aboutListItem.vue?vue&type=style&index=0&id=2018b9c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2018b9c9",
  null
  
)

export default component.exports